import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {UtilService} from "../../services/util.service";

@Component({
  selector: 'app-file-attachments',
  templateUrl: './file-attachments.component.html',
  styleUrls: ['./file-attachments.component.scss']
})
export class FileAttachmentsComponent implements OnInit {
  files: any[] = [];
  uploadedFiles: any[] = [];
  @Output() fileDropped = new EventEmitter();
  @Output() fileUpload = new EventEmitter();
  @Input() fileLoading: boolean = false;
  @Input() hideUploadButton: boolean = false;
  @Input() supportedFiles: string[] | string;
  constructor(private utilservice: UtilService) { }

  ngOnInit(): void {
  }

  onFileDropped($event) {
    let unSupportedFiles: string[] | string = [];
    for(let file of $event){
      if(this.supportedFiles.length){
        let unSupport = true;
        if(typeof this.supportedFiles === 'object') {
          for (let support of this.supportedFiles) {
            if (file.name.toLowerCase().indexOf(support.toLowerCase()) >= 0) {
              this.files.push(file);
              unSupport = false;
              break;
            }
          }
        }else{
          if (file.name.toLowerCase().indexOf(this.supportedFiles.toLowerCase()) >= 0) {
            this.files.push(file);
            unSupport = false;
          }
        }
        if(unSupport){
          unSupportedFiles.push(file.name);
        }
      }else{
        this.files.push(file);
      }
    }
    if(unSupportedFiles.length){
      this.utilservice.errorMessage(`${unSupportedFiles.join(', ')} files are not supported`);
    }

    this.fileDropped.emit(this.files);
  }

  deleteFile(ind){
    this.files.splice(ind, 1);
    this.fileDropped.emit(this.files);
  }

  uploadFiles(e){
    e.stopImmediatePropagation();
    // this.uploadedFiles = this.uploadedFiles.concat(this.files);
    this.fileUpload.emit();
    this.files = this.files.map(item => {
      item.uploaded = true;
      return item;
    });
    this.fileDropped.emit(this.files);
  }

  disableUpload(files){
    let disabled = true;
    for(let file of files){
      if(!file.uploaded){
        disabled = false;
        break;
      }
    }
    return disabled;
  }

  reset(){
    this.files = [];
  }

}
